import Workflow from './base';

import { CLUBS_TYPES } from '@domui-domain/districts/constants';
import { DomuiError, DynamicData } from '@domui-domain/type';

class Member extends Workflow {
  constructor() {
    super('memberwf');
  }

  async GetAffiliationAndClubsInfo(individualId: string) {
    this.setAction('GetAffiliationAndClubsInfo');
    this.setData({
      individualId,
    });

    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async ClubMembersSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData,
    id: string | null
  ) {
    this.setAction('clubMembersSearch');
    this.setData({
      pageNumber,
      pageSize,
      searchAndFilterData: data,
      id,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async DistrictMembersSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('districtMembersSearch');
    this.setData({
      pageNumber,
      pageSize,
      searchAndFilterData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async DistrictClubsSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('districtClubsSearch');

    // Ensure data and filters exist, then check clubTypes
    const modifiedData = {
      ...data,
      filters: {
        ...(data?.filters ?? {}),
        clubTypes:
          Array.isArray(data?.filters?.clubTypes) &&
          data?.filters?.clubTypes.length > 0
            ? data?.filters?.clubTypes
            : CLUBS_TYPES,
      },
    };

    this.setData({
      pageNumber,
      pageSize,
      searchAndFilterData: modifiedData,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async AddMembersSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('addMembersSearch');
    this.setData({
      pageNumber,
      pageSize,
      searchMemberData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async FetchExistingEmail(data: DynamicData) {
    this.setAction('fetchExistingEmail');
    this.setData({
      putData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchPossibleSponsors(
    admissionDate: string,
    clubId: string,
    action: string,
    alreadySponsoredBy: DynamicData
  ) {
    const data = {
      admissionDate,
      clubId,
      action,
      alreadySponsoredBy,
    };
    this.setAction('fetchPossibleSponsors');
    this.setData({
      putData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async AddMemberToClub(data: DynamicData) {
    this.setAction('addMemberToClub');
    this.setData({
      putData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async RemoveFromAssignedRole(data: DynamicData) {
    this.setAction('removeFromAssignedRole');
    this.setData({
      requestData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async FetchPreviousOfficers(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('fetchPreviousOfficers');
    this.setData({
      pageNumber,
      pageSize,
      putData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async AssignRoleToMember(data: DynamicData) {
    this.setAction('assignRoleToMember');
    this.setData({
      requestData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async MembershipActions(orgId: string, individualId: string) {
    this.setAction('membershipActions');
    this.setData({
      orgId,
      individualId,
    });

    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async EditClubMembership(data: DynamicData) {
    this.setAction('editClubMembership');
    this.setData({
      requestData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async ReplaceOfficer(data: DynamicData) {
    this.setAction('replaceOfficer');
    this.setData({
      requestData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async GetTerminationReason() {
    this.setAction('getTerminationReason');
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async TerminateClubMembership(data: DynamicData) {
    this.setAction('terminateClubMembership');
    this.setData({
      requestData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async AllActiveClubsByDistrictAndRotaryYear(data: DynamicData) {
    this.setAction('allActiveClubsByDistrictAndRotaryYear');
    this.setData({
      requestData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async AssistantDistrictGovernorsWithAssignedClubs(data: DynamicData) {
    this.setAction('assistantDistrictGovernorsWithAssignedClubs');
    this.setData({
      requestData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async PrevYearAssistantDistrictGovernorsWithAssignedClubs(data: DynamicData) {
    this.setAction('prevYearAssistantDistrictGovernorsWithAssignedClubs');
    this.setData({
      requestData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async findMemberSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('findMemberSearch');
    this.setData({
      pageNumber,
      pageSize,
      putData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async UpdateClubAssignmentsForAssistantGovernors(requestData: DynamicData) {
    this.setAction('updateClubAssignmentsForAssistantGovernors');
    this.setData({
      requestData,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async AddMemberToClubInfo(individualId: string) {
    this.setAction('addMemberToClubInfo');
    this.setData({
      individualId,
    });

    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async ReplaceAssistantGovernor(data: DynamicData) {
    this.setAction('ReplaceAssistantGovernor');
    this.setData({
      requestData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async AssignClubOfficerRole(data: DynamicData) {
    this.setAction('assignClubOfficerRole');
    this.setData({
      requestData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getMembershipSocietyInfo() {
    this.setAction('getMembershipSocietyInfo');
    try {
      const res = await this.getCall();

      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async DelegationClubMembersSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('delegationClubMembersSearch');
    this.setData({
      pageNumber,
      pageSize,
      searchAndFilterData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async DelegationDistrictMembersSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('delegationDistrictMembersSearch');
    this.setData({
      pageNumber,
      pageSize,
      searchAndFilterData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async DistrictListWithMembersCount(regionalPk: string) {
    this.setAction('districtListWithMembersCount');
    this.setData({
      regionalPk,
    });

    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchAssistantRegionalOfficers(payloadData: DynamicData) {
    this.setAction('fetchAssistantRegionalOfficers');
    this.setData({
      payloadData,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }
}

export default Member;
